<template>
  <div class="products-list-wrap">
    <div class="products-switches" v-if="!loading && safeItems.length">
      <label class="products-switch" :class="{ 'is-on': productNameOptions.copyName }">
        <input type="checkbox" v-model="productNameOptions.copyName" @change="storeConfigProductNameOptions">
        <b-icon icon="files"></b-icon>
        <span>کپی نام</span>
      </label>
      <label class="products-switch" :class="{ 'is-on': productNameOptions.searchInGoogle }">
        <input type="checkbox" v-model="productNameOptions.searchInGoogle" @change="storeConfigProductNameOptions">
        <b-icon icon="google"></b-icon>
        <span>سرچ گوگل</span>
      </label>
      <label class="products-switch" :class="{ 'is-on': productNameOptions.searchInGoogleImage }">
        <input type="checkbox" v-model="productNameOptions.searchInGoogleImage" @change="storeConfigProductNameOptions">
        <b-icon icon="images"></b-icon>
        <span>سرچ عکس</span>
      </label>
    </div>

    <div v-if="loading" class="products-loading">
      <div class="spinner-border" role="status"></div>
      <p class="mb-0">در حال بارگذاری محصولات...</p>
    </div>

    <div v-else-if="!safeItems.length" class="products-empty">
      <i class="bi bi-box-seam"></i>
      <p class="mb-0">محصولی برای نمایش وجود ندارد.</p>
      <router-link v-if="restoreState !== true" class="products-empty-btn" :to="{ name: 'CreateProduct' }">
        ساخت محصول
      </router-link>
    </div>

    <div v-else>
      <div class="d-lg-none">
        <article v-for="item in safeItems" :key="'card-' + item.id" class="product-card"
                 :class="{ 'is-selected': selectable && isSelected(item) }">
          <div class="product-card-top">
            <label v-if="selectable" class="product-select" @click.stop>
              <input type="checkbox" :checked="isSelected(item)" @change="toggleSelect(item)">
            </label>
            <span class="product-id-chip">#{{ item.id }}</span>
            <span class="product-badge" :class="item.is_digital == 0 ? 'is-physical' : 'is-digital'">
              {{ item.is_digital == 0 ? 'فیزیکی' : 'دیجیتال' }}
            </span>
          </div>

          <div class="product-card-identity">
            <div class="product-card-thumb">
              <product-image-manager :product="item"/>
            </div>
            <div class="product-card-title">
            <div class="product-card-head">
              <m-a class="product-card-name" target="_blank" :href="{ name: 'Product', params: { name: item.raw_link } }">
                {{ item.name }}
              </m-a>
              <div class="product-name-tools">
                <button v-if="productNameOptions.copyName" type="button" class="product-name-tool" @click="copyProductName(item)">
                  <b-icon icon="files"/>
                </button>
                <a v-if="productNameOptions.searchInGoogle" class="product-name-tool" :href="productNameSearchInGoogle(item)" target="_blank">
                  <b-icon icon="google"/>
                </a>
                <a v-if="productNameOptions.searchInGoogleImage" class="product-name-tool" :href="productNameSearchInGoogleImage(item)" target="_blank">
                  <b-icon icon="images"/>
                </a>
              </div>
            </div>
              <div class="product-card-tags">
                <span v-if="item.is_digital==0 && item.brand" class="product-badge is-brand">{{ item.brand.name }}</span>
                <status-changer :item="item" item-type="product"/>
                <holoo-status :item="item"/>
              </div>
            </div>
          </div>

          <div class="product-card-meta">
            <div class="product-meta-box">
              <update-product-general-info :product="item" mode="price"/>
            </div>
            <div class="product-meta-box">
              <update-product-general-info :product="item" mode="offer"/>
            </div>
            <div class="product-meta-box">
              <update-product-general-info v-if="item.variation == 0" :product="item" mode="quantity"/>
              <template v-else>
                <span>تعداد</span>
                <strong>متغیر</strong>
              </template>
            </div>
            <div class="product-meta-box">
              <update-product-general-info :product="item" mode="order"/>
            </div>
            <div class="product-meta-box product-meta-cats" v-if="item.category && item.category.length">
              <span>دسته</span>
              <div class="product-cats-wrap">
                <span v-for="el in item.category" :key="item.id + '-cat-' + el.id" class="product-badge is-cat">{{ el.name }}</span>
              </div>
            </div>
            <div class="product-meta-box product-meta-actions">
              <span>عملیات</span>
              <div class="product-actions">
                <template v-if="restoreState === true">
                  <span @click="forceDeleteProduct(item)" class="product-action-btn is-danger" v-b-tooltip.hover title="حذف دائمی">
                    <b-icon icon="trash"/>
                  </span>
                  <span class="product-action-btn" v-b-tooltip.hover title="بازگردانی" @click="restore(item)">
                    <b-icon icon="arrow-clockwise"></b-icon>
                  </span>
                </template>
                <template v-else>
                  <m-a target="_blank" class="product-action-btn" :href="{ name: 'EditProduct', params: { slug: item.raw_link } }" v-b-tooltip.hover title="ویرایش">
                    <b-icon icon="pencil"/>
                  </m-a>
                  <span @click="deleteProduct(item)" class="product-action-btn is-danger" v-b-tooltip.hover title="حذف">
                    <b-icon icon="trash"/>
                  </span>
                  <duplicate-item class="product-action-btn" :item="item" item-type="product"/>
                  <span v-b-modal="`share-modal-${item.id}`" class="product-action-btn" v-b-tooltip.hover title="اشتراک‌گذاری">
                    <b-icon icon="share-fill"/>
                  </span>
                  <b-modal :id="`share-modal-${item.id}`" hide-footer>
                    <div class="text-right" dir="rtl">
                      <share-form :item="item" :shareable_id="item.id" shareable_type="product"/>
                    </div>
                  </b-modal>
                </template>
              </div>
            </div>
          </div>
        </article>
      </div>

      <div class="table-responsive d-none d-lg-block">
        <table class="products-table">
          <thead>
          <tr>
            <th v-if="selectable" class="product-select-cell">
              <label class="product-select" title="انتخاب همه این صفحه">
                <input type="checkbox" :checked="allPageSelected" @change="togglePage">
              </label>
            </th>
            <th>عکس</th>
            <th>نام</th>
            <th>وضعیت</th>
            <th>قیمت/تخفیف</th>
            <th>تعداد / ترتیب</th>
            <th class="product-brand-cell">برند</th>
            <th class="product-type-cell">نوع</th>
            <th>دسته</th>
            <th>عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in safeItems" :key="'row-' + item.id" :class="{ 'is-selected': selectable && isSelected(item) }">
            <td v-if="selectable" class="product-select-cell">
              <label class="product-select">
                <input type="checkbox" :checked="isSelected(item)" @change="toggleSelect(item)">
              </label>
            </td>
            <td class="product-identity-cell">
              <div class="product-table-identity">
                <div class="product-table-thumb">
                  <product-image-manager :product="item"/>
                </div>
                <span class="product-id-chip">{{ item.id }}</span>
              </div>
            </td>
            <td class="product-name-cell">
              <m-a class="product-name-link" target="_blank" :href="{ name: 'Product', params: { name: item.raw_link } }">
                {{ item.name }}
              </m-a>
              <div class="product-name-tools">
                <button v-if="productNameOptions.copyName" type="button" class="product-name-tool" @click="copyProductName(item)">
                  <b-icon icon="files"/>
                </button>
                <a v-if="productNameOptions.searchInGoogle" class="product-name-tool" :href="productNameSearchInGoogle(item)" target="_blank">
                  <b-icon icon="google"/>
                </a>
                <a v-if="productNameOptions.searchInGoogleImage" class="product-name-tool" :href="productNameSearchInGoogleImage(item)" target="_blank">
                  <b-icon icon="images"/>
                </a>
              </div>
            </td>
            <td>
              <status-changer :item="item" item-type="product"/>
              <holoo-status :item="item"/>
            </td>
            <td class="product-price-cell" :class="{ 'is-variation': item.variation == 1 }">
              <update-product-general-info :product="item" mode="price"/>
              <update-product-general-info :product="item" mode="offer"/>
            </td>
            <td class="product-qty-order-cell">
              <update-product-general-info v-if="item.variation == 0" :product="item" mode="quantity"/>
              <span v-else class="product-muted">تعداد متغیر</span>
              <update-product-general-info :product="item" mode="order"/>
            </td>
            <td class="product-brand-cell">
              <span v-if="item.is_digital==0 && item.brand" class="product-badge is-brand">{{ item.brand.name }}</span>
              <span v-else class="product-muted">—</span>
            </td>
            <td class="product-type-cell">
              <span class="product-badge" :class="item.is_digital == 0 ? 'is-physical' : 'is-digital'">
                {{ item.is_digital == 0 ? 'فیزیکی' : 'دیجیتال' }}
              </span>
            </td>
            <td class="product-cats-cell">
              <div class="product-cats-wrap">
                <span v-for="el in item.category" :key="item.id + '-row-cat-' + el.id" class="product-badge is-cat">{{ el.name }}</span>
              </div>
            </td>
            <td>
              <div class="product-actions">
                <template v-if="restoreState === true">
                  <span @click="forceDeleteProduct(item)" class="product-action-btn is-danger" v-b-tooltip.hover title="حذف دائمی">
                    <b-icon icon="trash"/>
                  </span>
                  <span class="product-action-btn" v-b-tooltip.hover title="بازگردانی" @click="restore(item)">
                    <b-icon icon="arrow-clockwise"></b-icon>
                  </span>
                </template>
                <template v-else>
                  <m-a target="_blank" class="product-action-btn" :href="{ name: 'EditProduct', params: { slug: item.raw_link } }" v-b-tooltip.hover title="ویرایش">
                    <b-icon icon="pencil"/>
                  </m-a>
                  <span @click="deleteProduct(item)" class="product-action-btn is-danger" v-b-tooltip.hover title="حذف">
                    <b-icon icon="trash"/>
                  </span>
                  <duplicate-item class="product-action-btn" :item="item" item-type="product"/>
                  <span v-b-modal="`share-modal-row-${item.id}`" class="product-action-btn" v-b-tooltip.hover title="اشتراک‌گذاری">
                    <b-icon icon="share-fill"/>
                  </span>
                  <b-modal :id="`share-modal-row-${item.id}`" hide-footer>
                    <div class="text-right" dir="rtl">
                      <share-form :item="item" :shareable_id="item.id" shareable_type="product"/>
                    </div>
                  </b-modal>
                </template>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import UpdateProductGeneralInfo from "./UpdateProductGeneralInfo";
import StatusChanger from "../../genralComponents/StatusChanger";
import DuplicateItem from "../../genralComponents/DuplicateItem";
import ShareForm from "../Share/ShareForm.vue";
import ProductImageManager from "@/plugin/components/dashboard/product/ProductImageManager.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import HolooStatus from "../Holoo/components/HolooStatus.vue";
import "./products-ui.css";
import "./bulk-edit-ui.css";

export default {
  name: "tableItems",
  props: {
    items: {
      default: () => []
    },
    restoreState: {},
    loading: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    HolooStatus,
    ProductImageManager, ShareForm, UpdateProductGeneralInfo, StatusChanger, DuplicateItem,
  },
  data() {
    return {
      productNameOptions: {
        copyName: false,
        searchInGoogle: false,
        searchInGoogleImage: false
      }
    };
  },
  computed: {
    safeItems() {
      return Array.isArray(this.items) ? this.items : []
    },
    selectedIds() {
      const ids = this.$store.getters['ProductBulkEdit/selectedIds']
      return Array.isArray(ids) ? ids : []
    },
    allPageSelected() {
      return this.safeItems.length > 0 && this.safeItems.every((item) => this.selectedIds.indexOf(item.id) !== -1)
    }
  },
  methods: {
    formatNumber,
    isSelected(item) {
      return this.selectedIds.indexOf(item.id) !== -1
    },
    toggleSelect(item) {
      this.$store.dispatch('ProductBulkEdit/toggle', item.id)
    },
    togglePage() {
      const ids = this.safeItems.map((item) => item.id)
      this.$store.dispatch(this.allPageSelected ? 'ProductBulkEdit/unselectMany' : 'ProductBulkEdit/selectMany', ids)
    },
    deleteProduct(item) {
      if (confirm('آیا از حذف این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Product/deleteProduct", item);
      }
    },
    restore(product) {
      if (confirm('آیا از بازگردانی این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Product/restoreProduct", product);
      }
    },
    forceDeleteProduct(product) {
      if (confirm('آیا از حذف دائمی این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Product/forceDeleteProduct", product);
      }
    },
    copyProductName(product) {
      navigator.clipboard.writeText(product.name).then(function () {
        toast('کپی با موفقیت انجام شد', 'کپی با موفقیت انجام شد')
      }, function (err) {
        console.log('Copy Error => ', err)
      })
    },
    productNameSearchInGoogle(product) {
      const query = encodeURIComponent(product.name);
      return `https://www.google.com/search?q=${query}`
    },
    productNameSearchInGoogleImage(product) {
      const query = encodeURIComponent(product.name);
      return `https://www.google.com/search?tbm=isch&q=${query}`
    },
    storeConfigProductNameOptions() {
      localStorage.setItem('productNameOptions', JSON.stringify(this.productNameOptions))
    },
    loadConfigProductNameOptions() {
      let value = localStorage.getItem('productNameOptions')
      if (value != undefined) {
        try {
          this.productNameOptions = JSON.parse(value)
        } catch (e) {
          this.storeConfigProductNameOptions()
        }
      }
    },
  },
  mounted() {
    this.loadConfigProductNameOptions()
  }
};
</script>
